__turbopack_context__.v({
  "addLinkedinButton": "ContactDetails-module-scss-module__Z8_EtW__addLinkedinButton",
  "bg1": "ContactDetails-module-scss-module__Z8_EtW__bg1",
  "bg2": "ContactDetails-module-scss-module__Z8_EtW__bg2",
  "bottom": "ContactDetails-module-scss-module__Z8_EtW__bottom",
  "container": "ContactDetails-module-scss-module__Z8_EtW__container",
  "content": "ContactDetails-module-scss-module__Z8_EtW__content",
  "contentRoot": "ContactDetails-module-scss-module__Z8_EtW__contentRoot",
  "control": "ContactDetails-module-scss-module__Z8_EtW__control",
  "grayscale": "ContactDetails-module-scss-module__Z8_EtW__grayscale",
  "incomplete": "ContactDetails-module-scss-module__Z8_EtW__incomplete",
  "incompleteStrip": "ContactDetails-module-scss-module__Z8_EtW__incompleteStrip",
  "loginButton": "ContactDetails-module-scss-module__Z8_EtW__loginButton",
  "missingData": "ContactDetails-module-scss-module__Z8_EtW__missingData",
  "missingDataHeader": "ContactDetails-module-scss-module__Z8_EtW__missingDataHeader",
  "mobileOnly": "ContactDetails-module-scss-module__Z8_EtW__mobileOnly",
  "root": "ContactDetails-module-scss-module__Z8_EtW__root",
  "social": "ContactDetails-module-scss-module__Z8_EtW__social",
  "socialPreview": "ContactDetails-module-scss-module__Z8_EtW__socialPreview",
  "tablet": "ContactDetails-module-scss-module__Z8_EtW__tablet",
  "top": "ContactDetails-module-scss-module__Z8_EtW__top",
});
